import React from "react";
import { Routes, Route } from "react-router-dom";
import ReporteCierrePage from "../pages/ReporteCierrePage";

const ReporteCierreRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<ReporteCierrePage />} />
    </Routes>
  );
};

export default ReporteCierreRoutes;
